import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  FormControl,
  Checkbox,
  FormControlLabel,
  TextField,
  useMediaQuery,
  Fab,
  Alert,
  AlertTitle,
  Chip,
} from "@mui/material";
import { useState, FormEvent, useEffect } from "react";
import CommonModal from "./HWSubmitModal";
import { useCharactersContext } from "../hooks/Context";

interface Question {
  updatedBy: string;
  question: string;
  mediaUrl: string;
  difficultyLevel: string;
  answerType: number;
  active: boolean;
  marks: number;
  updatedDate: string;
  subjectId: number;
  questionBankId: number;
  classId: number;
  createdDate: string;
  createdBy: string;
  optionsList: Option[];
  questionPaperId: number;
  uiType: number;
  remarks: string;
}

interface Option {
  questionBankId: number;
  updatedBy: string;
  createdDate: string;
  createdBy: string;
  active: boolean;
  optionId: number;
  updatedDate: string;
  correctAnswer: boolean;
  option: string;
}

interface Layout11Props {
  Questions: Question[];
  currentQuestionIndex: number;
  setCurrentQuestionIndex: React.Dispatch<React.SetStateAction<number>>;
  sectionName: string;
}


const Layout11: React.FC<Layout11Props> = ({
  Questions,
  currentQuestionIndex,
  setCurrentQuestionIndex,
  sectionName,
}) => {
  // console.log("Layout 11 Questions: ", Questions);
  // console.log("currentQuestionIndex: ", currentQuestionIndex);
  const currentQuestion = Questions[currentQuestionIndex];
  const sentences = currentQuestion.question.split("<br>");
  const [modalOpen, setModalOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:820px)");
  // const [inputValues, setInputValues] = useState<string[]>([]);
  const [inputValues, setInputValues] = useState<string[]>(() => {
    const storageKey = `inputValuesLayout11_${sectionName}_${currentQuestion.questionPaperId}`;
    const savedState = localStorage.getItem(storageKey);
    return savedState
      ? JSON.parse(savedState)
      : Array(Questions.length).fill("");
  });
  const [isCorrectSubmission, setIsCorrectSubmission] = useState<
    boolean | null
  >(null);
  const [showAlert, setShowAlert] = useState(false);
  const handleAlertClose = () => setShowAlert(false);
  setTimeout(handleAlertClose, 3000);
  const {
    questionScores,
    setQuestionScores,
    isViewMode,
    examAnswers,
    setExamAnswers,
  } = useCharactersContext();

  const mediaUrls =
    currentQuestion?.mediaUrl?.split(",").map((url) => url.trim()) || [];

  const hasMultipleImages = mediaUrls.length > 1;

  const handleInputChange = (value: string, index: number) => {
    setInputValues((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index] = value;
      return updatedValues;
    });
  };

  const handleFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setShowAlert(true);

    if (currentQuestion.answerType === 6) {
      const combined = inputValues[currentQuestionIndex] || "";
      const enteredParts = combined.split(",").map((s: string) => s.trim().toLowerCase());
      const correctAnswer = Questions[currentQuestionIndex].optionsList[0].option;
      const correctParts = correctAnswer.split(",").map((s: string) => s.trim().toLowerCase());

      const isCorrectSubmission =
        enteredParts.length === correctParts.length &&
        enteredParts.every((e: string) => correctParts.includes(e)) &&
        correctParts.every((c: string) => enteredParts.includes(c));

      setIsCorrectSubmission(isCorrectSubmission);
      setModalOpen(true);

      const questionIndex = questionScores.findIndex(
        (item) => item.questionBankId === currentQuestion.questionBankId
      );
      if (questionIndex !== -1) {
        const updatedScores = [...questionScores];
        updatedScores[questionIndex] = {
          questionBankId: currentQuestion.questionBankId,
          questionPaperId: currentQuestion.questionPaperId,
          score: isCorrectSubmission ? currentQuestion.marks : 0,
          layoutNumber: currentQuestion.uiType,
          sectionName: sectionName,
        };
        setQuestionScores(updatedScores);
      } else {
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: isCorrectSubmission ? currentQuestion.marks : 0,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }

      const updatedExamAnswer = {
        questionBankId: currentQuestion.questionBankId,
        acutalOptionValue: correctAnswer,
        enteredOptionValue: combined,
      };
      const existingAnswerIndex = examAnswers.findIndex(
        (answer) => answer.questionBankId === currentQuestion.questionBankId
      );
      if (existingAnswerIndex !== -1) {
        setExamAnswers((prevAnswers) =>
          prevAnswers.map((answer, index) =>
            index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
          )
        );
      } else {
        setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
      }
      return;
    }

    if (currentQuestion.answerType === 1 || currentQuestion.answerType === 3 || currentQuestion.answerType === 4 || currentQuestion.answerType === 5) {
      const selectedWord = inputValues[currentQuestionIndex] || "";

      const correctAnswer =
        Questions[currentQuestionIndex].optionsList[0].option;
      // console.log("correct answer", correctAnswer);

      const selectedWordsArray = selectedWord.toLowerCase().split(/,\s*/);
      const correctWordsArray = correctAnswer.toLowerCase().split(/,\s*/);
      // console.log("selected words", selectedWordsArray);
      // console.log("correct words", correctWordsArray);

      const matchingWordsCount = selectedWordsArray.filter((word) =>
        correctWordsArray.includes(word)
      ).length;

      const cleanStr = (s: string) => s.trim().toLowerCase().replace(/\.+$/, "");
      const isCorrectSubmission = cleanStr(selectedWord) === cleanStr(correctAnswer);
      // console.log("isCorrectSubmission ", isCorrectSubmission);

      setIsCorrectSubmission(isCorrectSubmission);
      if (isCorrectSubmission) {
        setIsCorrectSubmission(true);
        //  console.log("Answer is correct", isCorrectSubmission);
        // playCorrectSound();
        setModalOpen(true);
        const questionIndex = questionScores.findIndex(
          (item) => item.questionBankId === currentQuestion.questionBankId
        );

        if (questionIndex !== -1) {
          // Update the existing score
          const updatedScores = [...questionScores];
          updatedScores[questionIndex] = {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          };
          setQuestionScores(updatedScores);
          // console.log("updatedScores ", questionScores);
          //console.log("updatedScores ", updatedScores);
        } else {
          // Add a new score for the question
          setQuestionScores((prevScores) => [
            ...prevScores,
            {
              questionBankId: currentQuestion.questionBankId,
              questionPaperId: currentQuestion.questionPaperId,
              score: currentQuestion.marks,
              layoutNumber: currentQuestion.uiType,
              sectionName: sectionName,
            },
          ]);
          //  console.log("prevScores ", questionScores);
        }
      } else {
        setIsCorrectSubmission(false);
        // playInCorrectSound();
        setModalOpen(true);
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: 0,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    } else if (currentQuestion.answerType === 2) {
      const selectedWord = inputValues[currentQuestionIndex] || "";
      // console.log("selected word", selectedWord);

      const correctAnswer =
        Questions[currentQuestionIndex].optionsList?.[0]?.option || "";
      //console.log("correct answer", correctAnswer);

      const cleanStr = (s: string) => s.trim().toLowerCase().replace(/\.+$/, "");

      const isOpenEnded =
        !correctAnswer ||
        correctAnswer.trim() === "" ||
        cleanStr(correctAnswer) === "open_ended" ||
        cleanStr(correctAnswer) === "n/a";

      const isExactMatch = cleanStr(selectedWord) === cleanStr(correctAnswer);

      const selectedWordsArray = selectedWord.toLowerCase().split(/,\s*/);
      const correctWordsArray = correctAnswer ? correctAnswer.toLowerCase().split(/,\s*/) : [];

      const matchingWordsCount = selectedWordsArray.filter((word) =>
        correctWordsArray.includes(word)
      ).length;

      const isCorrectSubmission = isOpenEnded
        ? selectedWord.trim().length > 0
        : (isExactMatch || (selectedWord.includes(",") && matchingWordsCount >= 2));

      if (isCorrectSubmission) {
        setIsCorrectSubmission(true);
        // console.log("Answer is correct", isCorrectSubmission);
        // playCorrectSound();
        setModalOpen(true);
        const questionIndex = questionScores.findIndex(
          (item) => item.questionBankId === currentQuestion.questionBankId
        );

        // console.log("questionIndex", questionIndex);

        if (questionIndex !== -1) {
          // Update the existing score
          const updatedScores = [...questionScores];
          updatedScores[questionIndex] = {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks || 1,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          };
          setQuestionScores(updatedScores);
          // console.log("updatedScores ", questionScores);
          //console.log("updatedScores ", updatedScores);
        } else {
          // Add a new score for the question
          setQuestionScores((prevScores) => [
            ...prevScores,
            {
              questionBankId: currentQuestion.questionBankId,
              questionPaperId: currentQuestion.questionPaperId,
              score: currentQuestion.marks || 1,
              layoutNumber: currentQuestion.uiType,
              sectionName: sectionName,
            },
          ]);
          // console.log("prevScores ", questionScores);
        }
      } else {
        setIsCorrectSubmission(false);
        // playInCorrectSound();
        setModalOpen(true);
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: 0,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    }

    if (currentQuestion.answerType === 1 || currentQuestion.answerType === 3 || currentQuestion.answerType === 4 || currentQuestion.answerType === 5) {
      const selectedWord = inputValues[currentQuestionIndex] || "";

      const correctAnswer =
        Questions[currentQuestionIndex].optionsList[0].option;
      // console.log("correct answer", correctAnswer);

      const selectedWordsArray = selectedWord.toLowerCase().split(/,\s*/);
      const correctWordsArray = correctAnswer.toLowerCase().split(/,\s*/);
      // console.log("selected words", selectedWordsArray);
      // console.log("correct words", correctWordsArray);

      const updatedExamAnswer = {
        questionBankId: currentQuestion.questionBankId,
        acutalOptionValue: correctWordsArray.join(","),
        enteredOptionValue: selectedWordsArray.join(","),
      };

      // Reset selectedOptions for the next question
      //setSelectedOptions([]);

      // Check if there is already an answer for the current question
      const existingAnswerIndex = examAnswers.findIndex(
        (answer) => answer.questionBankId === currentQuestion.questionBankId
      );

      if (existingAnswerIndex !== -1) {
        // If an answer already exists, update the existing one
        setExamAnswers((prevAnswers) =>
          prevAnswers.map((answer, index) =>
            index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
          )
        );
      } else {
        // If there is no existing answer, add the new answer
        setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
      }

      //  console.log("updatedExamAnswer ", updatedExamAnswer);
      //  console.log("examAnswers  ", examAnswers);
    } else if (currentQuestion.answerType === 2) {
      const selectedWord = inputValues[currentQuestionIndex] || "";
      //  console.log("selected word", selectedWord);

      const correctAnswer =
        Questions[currentQuestionIndex].optionsList?.[0]?.option || "";

      const updatedExamAnswer = {
        questionBankId: currentQuestion.questionBankId,
        acutalOptionValue: correctAnswer || "Open Ended",
        enteredOptionValue: selectedWord,
      };

      // Reset selectedOptions for the next question
      //setSelectedOptions([]);

      // Check if there is already an answer for the current question
      const existingAnswerIndex = examAnswers.findIndex(
        (answer) => answer.questionBankId === currentQuestion.questionBankId
      );

      if (existingAnswerIndex !== -1) {
        // If an answer already exists, update the existing one
        setExamAnswers((prevAnswers) =>
          prevAnswers.map((answer, index) =>
            index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
          )
        );
      } else {
        // If there is no existing answer, add the new answer
        setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
      }

      //  console.log("updatedExamAnswer ", updatedExamAnswer);
      // console.log("examAnswers  ", examAnswers);
    }
  };

  const playCorrectSound = () => {
    const correctSound = new Audio(
      require("../assets/correct-choice-43861.mp3")
    );
    correctSound.play();
    handleOpen();
  };

  const playInCorrectSound = () => {
    const incorrectSound = new Audio(
      require("../assets/wronganswer-37702.mp3")
    );
    incorrectSound.play();
    handleOpen();
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const handleContinue = () => {
    setCurrentQuestionIndex((prevIndex) =>
      Math.min(prevIndex + 1, Questions.length - 1)
    );
    setModalOpen(false);
  };

  const handleRetry = () => {
    // setSelectedOptions([]);
    setInputValues([]);
    setModalOpen(false);
  };

  const renderUIBasedOnAnswerType = () => {
    switch (currentQuestion.answerType) {
      case 1:
        return (
          <>
            <FormControl>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row",
                  // mt: 2,
                  // flexWrap: "wrap",
                  // gap: "8px",
                }}
              >
                {sentences[1] && (
                  <Typography sx={{ mt: isMobile ? "12px" : "10px" }}>
                    {sentences[1]}
                  </Typography>
                )}
                <TextField
                  variant="standard"
                  sx={{
                    width: "150px",
                    ...(sectionName === "Grammar" && {
                      backgroundColor: "lightcoral",
                      borderRadius: "5px",
                    }),
                  }}
                  value={inputValues[currentQuestionIndex] || ""}
                  onChange={(event) =>
                    handleInputChange(event.target.value, currentQuestionIndex)
                  }
                />
              </Box>
            </FormControl>
          </>
        );
      case 6: {
        const combined = inputValues[currentQuestionIndex] || "";
        const parts = combined.split(",");
        const val1 = parts[0] || "";
        const val2 = parts[1] || "";
        const handlePart = (partIndex: number, value: string) => {
          const current = inputValues[currentQuestionIndex] || "";
          const arr = current.split(",");
          arr[partIndex] = value;
          handleInputChange(arr.join(","), currentQuestionIndex);
        };
        return (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
            {sentences[1] && (
              <Typography sx={{ textAlign: "center", fontSize: isMobile ? "100%" : "110%" }}>
                {sentences[1]}
              </Typography>
            )}
            <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
              <TextField
                variant="standard"
                sx={{ width: "150px" }}
                value={val1}
                onChange={(e) => handlePart(0, e.target.value)}
              />
              <TextField
                variant="standard"
                sx={{ width: "150px" }}
                value={val2}
                onChange={(e) => handlePart(1, e.target.value)}
              />
            </Box>
          </Box>
        );
      }
      case 2:
        return (
          <>
            <TextField
              id="filled-basic"
              label="Type your answer here"
              multiline
              minRows={3}
              maxRows={6}
              sx={{
                width: "100%",
                mt: 1,
              }}
              value={inputValues[currentQuestionIndex] || ""}
              onChange={(event) =>
                handleInputChange(event.target.value, currentQuestionIndex)
              }
            />
          </>
        );
      case 3:
        return (
          <>
            <TextField
              id="filled-basic"
              label="Type your answer here"
              sx={{
                width: "auto",
              }}
              value={inputValues[currentQuestionIndex] || ""}
              onChange={(event) =>
                handleInputChange(event.target.value, currentQuestionIndex)
              }
            />
          </>
        );
      case 4:
        return (
          <>
            <TextField
              id="filled-basic"
              label="Type your answer here"
              sx={{
                width: "auto",
              }}
              value={inputValues[currentQuestionIndex] || ""}
              onChange={(event) =>
                handleInputChange(event.target.value, currentQuestionIndex)
              }
            />
          </>
        );
      case 5:
        return (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: "center",
                width: "100%",
              }}
            >
              {/* Green box with options */}
              {sentences[2] && (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    justifyContent: "center",
                    p: 2,
                    backgroundColor: "#4caf50",
                    borderRadius: 2,
                    border: "2px solid #388e3c",
                    maxWidth: "90%",
                  }}
                >
                  {sentences[2].split(",").map((option: string, index: number) => (
                    <Chip
                      key={index}
                      label={option.trim()}
                      sx={{
                        backgroundColor: "white",
                        color: "#2e7d32",
                        fontWeight: 500,
                        cursor: "default",
                        "&:hover": {
                          backgroundColor: "white",
                        },
                      }}
                    />
                  ))}
                </Box>
              )}
              {/* Question sentence */}
              {sentences[1] && (
                <Typography
                  sx={{
                    fontSize: isMobile ? "1rem" : "1.1rem",
                    textAlign: "center",
                    mt: 1,
                  }}
                >
                  {sentences[1]}
                </Typography>
              )}
              {/* Text input field */}
              <TextField
                id="filled-basic"
                label="Type your answer here"
                sx={{
                  width: "100%",
                  maxWidth: "400px",
                  mt: 2,
                }}
                value={inputValues[currentQuestionIndex] || ""}
                onChange={(event) =>
                  handleInputChange(event.target.value, currentQuestionIndex)
                }
              />
            </Box>
          </>
        );
    }
  };

  useEffect(() => {
    const storageKey = `inputValuesLayout11_${sectionName}_${currentQuestion.questionPaperId}`;
    localStorage.setItem(storageKey, JSON.stringify(inputValues));
  }, [inputValues]);

  useEffect(() => {
    if (isViewMode) {
      const correctAnswers = Questions.map((question) => {
        if (question.answerType === 1 || question.answerType === 3 || question.answerType === 6) {
          return question.optionsList[0]?.option || "" || "";
        } else if (question.answerType === 2) {
          return question.optionsList[0]?.option || "" || "";
        } else if (question.answerType === 4 || question.answerType === 5) {
          // For answerType 4 and 5, check remarks field first
          return question.remarks || question.optionsList[0]?.option || "" || "";
        } else {
          return "";
        }
      });

      setInputValues(correctAnswers);
    }
  }, [currentQuestion]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "auto",
        marginTop:
          isMobile && isViewMode
            ? "9%"
            : isMobile
              ? "auto"
              : isTablet
                ? "20%"
                : isViewMode
                  ? "10%"
                  : "3%",
      }}
    >
      {/* <CommonModal
        open={modalOpen}
        isCorrectSubmission={isCorrectSubmission}
        handleContinue={handleContinue}
        handleRetry={handleRetry}
        handleClose={handleClose}
      /> */}
      {showAlert && (
        <Alert
          severity="success"
          variant="filled"
          sx={{
            position: "fixed",
            top: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            padding: "0.5",
          }}
        >
          <AlertTitle sx={{ color: "white" }}>Answer submitted</AlertTitle>
        </Alert>
      )}
      {currentQuestion && (
        <Card
          variant="outlined"
          sx={{
            borderRadius: "12px",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
            pointerEvents: isViewMode ? "none" : "auto",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                paddingBottom: "0px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: isMobile ? "100%" : "110%",
                  marginBottom: currentQuestion.answerType === 5 ? "1vh" : "2vh",
                }}
              >
                {sentences[0]}
              </Typography>
              {currentQuestion.mediaUrl &&
                (hasMultipleImages ? (
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    {mediaUrls.map((url, index) => (
                      <img
                        key={index}
                        src={url}
                        alt={`image-${index}`}
                        width="100"
                        height="100"
                      />
                    ))}
                  </Box>
                ) : (
                  <img
                    src={mediaUrls[0]}
                    alt="image"
                    width="100"
                    height="100"
                  />
                ))}

              {(currentQuestion.answerType === 2 ||
                currentQuestion.answerType === 3 ||
                currentQuestion.answerType === 4) && (
                  <>
                    <Fab
                      variant="extended"
                      sx={{
                        fontWeight: 600,
                        fontSize:
                          sectionName === "Pictionary"
                            ? isMobile
                              ? "15px"
                              : "20px"
                            : isMobile
                              ? "0.95rem"
                              : "1.1rem",
                        cursor: "default",
                        fontFamily: '"Nunito","Segoe UI", sans-serif',
                        backgroundColor: "#E12027 !important",
                        color: "white",
                        p: isMobile ? 1.5 : 2,
                        m: 1,
                        boxShadow: "none",
                        whiteSpace: "normal",
                        height: "auto",
                        minHeight: "48px",
                        maxWidth: isMobile ? "90vw" : "600px",
                        wordBreak: "break-word",
                        textTransform: "none",
                      }}
                    >
                      {sentences[1]}
                    </Fab>
                    {currentQuestion.answerType === 4 && sentences[2] && (
                      <Chip
                        label={sentences[2]}
                        variant="outlined"
                        sx={{
                          borderColor: "#1976d2",
                          color: "#1976d2",
                          fontWeight: 500,
                          fontSize: isMobile ? "0.9rem" : "1rem",
                          mt: 1,
                          mb: 1,
                          cursor: "default",
                          "&:hover": {
                            borderColor: "#1976d2",
                            backgroundColor: "transparent",
                          },
                        }}
                      />
                    )}
                  </>
                )}
            </Box>

            <form onSubmit={handleFormSubmit}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 0,
                }}
              >
                {renderUIBasedOnAnswerType()}
              </Box>
              {!isViewMode && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                  }}
                >
                  <Button type="submit" variant="contained">
                    Submit
                  </Button>
                </Box>
              )}
            </form>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default Layout11;

